module.exports = __webpack_public_path__ + "static/media/galerija_2019 (14).35749932.jpg";